import {PublicCatalogPage,PublicCatalogQuery,PUBLIC_CATALOG_LIMITS,type PublicCatalogPageData,type PublicCatalogQueryData} from '@zzy/contracts';

export const apiTabs=[{id:'models',label:'模型与价格'},{id:'docs',label:'接入文档'}] as const;

export const catalogCategories=[
  {id:'chat',label:'对话'},{id:'image',label:'图片'},{id:'video',label:'视频'},
  {id:'audio',label:'音频'},{id:'embedding',label:'向量'},{id:'rerank',label:'重排'},{id:'other',label:'其他'},
] as const;

// Client integration seam, not a new HTTP contract. The server owns site identity,
// anonymous access, projection, filtering, byte-order sorting and signed cursors.
export type PublicCatalogReader=(query:PublicCatalogQueryData,signal:AbortSignal)=>Promise<PublicCatalogPageData>;
export class CatalogReadError extends Error {
  constructor(readonly reason:'unavailable'|'read_failed'|'invalid_response'|'snapshot_changed'|'timeout'){super(reason)}
}
export type CatalogReadState=
  | {status:'unavailable'|'loading'}
  | {status:'error';reason:'read_failed'|'invalid_response'|'snapshot_changed'|'timeout'}
  | {status:'success';page:PublicCatalogPageData};
export const initialCatalogQuery=()=>PublicCatalogQuery.parse({});
export function changeCatalogFilters(query:PublicCatalogQueryData,patch:Partial<Omit<PublicCatalogQueryData,'cursor'>>):PublicCatalogQueryData {
  const {cursor:_cursor,...filters}=query;
  return PublicCatalogQuery.parse({...filters,...patch});
}
export function catalogSnapshotKey(snapshot:PublicCatalogPageData['snapshot']):string {
  return JSON.stringify([snapshot.sourceId,snapshot.sourceRevision,snapshot.sitePublicationRevision,snapshot.visibilityRevision,snapshot.contentVersion,snapshot.pricingVersion]);
}

// One bounded request at a time. Even a reader ignoring AbortSignal cannot replace
// a newer result; a cursor page from another snapshot is never merged/displayed.
export function createCatalogReadSession(reader?:PublicCatalogReader) {
  let generation=0,active:AbortController|undefined;
  return {
    cancel(){generation++;active?.abort();active=undefined},
    async read(query:PublicCatalogQueryData,expectedSnapshot?:string):Promise<CatalogReadState|null>{
      const ticket=++generation;active?.abort();
      if(!reader)return {status:'unavailable'};
      const controller=new AbortController();active=controller;
      let timer:ReturnType<typeof setTimeout>|undefined,timedOut=false;
      try {
        const parsedQuery=PublicCatalogQuery.parse(query);
        const raw=await Promise.race([
          reader(parsedQuery,controller.signal),
          new Promise<never>((_resolve,reject)=>{timer=setTimeout(()=>{timedOut=true;controller.abort();reject(new Error('CATALOG_TIMEOUT'))},PUBLIC_CATALOG_LIMITS.timeoutMs)}),
        ]);
        if(ticket!==generation)return null;
        const result=PublicCatalogPage.safeParse(raw);
        if(!result.success)return {status:'error',reason:'invalid_response'};
        if(expectedSnapshot&&catalogSnapshotKey(result.data.snapshot)!==expectedSnapshot)return {status:'error',reason:'snapshot_changed'};
        return {status:'success',page:result.data};
      } catch(error) {
        if(ticket!==generation)return null;
        if(error instanceof CatalogReadError){
          if(error.reason==='unavailable')return {status:'unavailable'};
          return {status:'error',reason:timedOut?'timeout':error.reason};
        }
        return {status:'error',reason:timedOut?'timeout':'read_failed'};
      } finally {
        if(timer!==undefined)clearTimeout(timer);
        if(ticket===generation)active=undefined;
      }
    },
  };
}
